import React from 'react';
import { Layout } from '@synergy-marine-group/synergy-ui';
import { NavigationContext } from './NavigationProvider';

const NavChild = () => {
  const { ...navProps } = React.useContext(NavigationContext);
  return (
    <>
      <Layout {...navProps} />
    </>
  );
};

export default NavChild;
